export default "__VITE_ASSET__SmpfD$7U__"